import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getCameraProtocols } from './api';
import type { GetCameraProtocolsResponse } from './types';

export const CameraProtocolsControlGate = createGate<void>();

const fxGetCameraProtocols = createEffect<void, GetCameraProtocolsResponse, Error>().use(
  getCameraProtocols
);

export const cameraProtocolsQuery = createQuery({
  name: 'camera-protocols',
  effect: fxGetCameraProtocols,
  mapData: ({ result }) =>
    Array.isArray(result) ? result.map(({ id, title }) => ({ id, label: title })) : [],
});

sample({
  clock: CameraProtocolsControlGate.open,
  source: CameraProtocolsControlGate.status,
  filter: (status) => Boolean(status),
  target: cameraProtocolsQuery.start,
});
